(function($,Drupal) {

  const bodyClasses = document.body.classList;

  // Catch resolutions which are almost square.
  const isPortait = () => {
    return window.innerWidth - window.innerHeight <= -20;
  }

  const setRemovePortraitClass = () => {
    if (isPortait()) {
      bodyClasses.add('portrait');
    } else {
      bodyClasses.remove('portrait');
    }
  }

  $(window).on('resize', Drupal.debounce(setRemovePortraitClass, 200));

  setRemovePortraitClass();

})(jQuery, Drupal);
